var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriseReseau(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke-width:0.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prise_reseau",
    "data-name": "prise reseau"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.09,43.08a.49.49,0,0,1-.48-.48V41.2a.49.49,0,0,1,.48-.48.48.48,0,0,1,.48.48v1.4A.48.48,0,0,1,45.09,43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.17,52.94H14.4a2.41,2.41,0,0,1-2.4-2.4V21.77a2.41,2.41,0,0,1,2.4-2.4H43.17a2.39,2.39,0,0,1,2.4,2.4v11.3a.47.47,0,0,1-.48.47.48.48,0,0,1-.48-.47V21.77a1.43,1.43,0,0,0-1.44-1.44H14.4A1.44,1.44,0,0,0,13,21.77V50.54A1.45,1.45,0,0,0,14.4,52H43.17a1.44,1.44,0,0,0,1.44-1.44V46a.48.48,0,0,1,.48-.47.47.47,0,0,1,.48.47v4.59A2.4,2.4,0,0,1,43.17,52.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.09,38.33a.49.49,0,0,1-.48-.48V36.42a.49.49,0,0,1,.48-.48.48.48,0,0,1,.48.48v1.43A.48.48,0,0,1,45.09,38.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.8,47.66h-10a.48.48,0,0,1-.48-.48v-4h-4a.47.47,0,0,1-.48-.48v-6h-3a.48.48,0,0,1-.48-.48v-11a.49.49,0,0,1,.48-.48H41.82a.48.48,0,0,1,.48.48v11a.47.47,0,0,1-.48.48h-3v6a.48.48,0,0,1-.48.48h-4v4A.47.47,0,0,1,33.8,47.66Zm-9.55-1h9.07v-4a.49.49,0,0,1,.48-.48h4v-6a.48.48,0,0,1,.48-.48h3V25.6H16.23V35.67h3a.49.49,0,0,1,.48.48v6h4a.48.48,0,0,1,.48.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.9,31.56a.48.48,0,0,1-.48-.48v-2.6A.48.48,0,0,1,37.9,28a.49.49,0,0,1,.48.48v2.6A.49.49,0,0,1,37.9,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.25,31.56a.49.49,0,0,1-.48-.48v-2.6a.49.49,0,0,1,.48-.48.48.48,0,0,1,.48.48v2.6A.48.48,0,0,1,34.25,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.61,31.56a.48.48,0,0,1-.48-.48v-2.6a.48.48,0,0,1,.48-.48.49.49,0,0,1,.48.48v2.6A.49.49,0,0,1,30.61,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27,31.56a.48.48,0,0,1-.47-.48v-2.6a.48.48,0,1,1,1,0v2.6A.48.48,0,0,1,27,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.32,31.56a.49.49,0,0,1-.48-.48v-2.6a.49.49,0,0,1,.48-.48.48.48,0,0,1,.48.48v2.6A.48.48,0,0,1,23.32,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.68,31.56a.48.48,0,0,1-.48-.48v-2.6a.48.48,0,0,1,.48-.48.49.49,0,0,1,.48.48v2.6A.49.49,0,0,1,19.68,31.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.33,18a2.31,2.31,0,0,1,.55,1.69.77.77,0,1,0,1.53.12,3.77,3.77,0,0,0-.9-2.8,3.81,3.81,0,0,0-2.63-1.35.75.75,0,0,0-.56.18.77.77,0,0,0,.44,1.36A2.29,2.29,0,0,1,47.33,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,19.92a.77.77,0,1,0,1.54.12,7,7,0,0,0-6.36-7.48.84.84,0,0,0-.56.18.8.8,0,0,0-.27.53.77.77,0,0,0,.71.83A5.41,5.41,0,0,1,51,19.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54,20.17a.77.77,0,1,0,1.54.12,10,10,0,0,0-9.18-10.8.75.75,0,0,0-.56.18A.77.77,0,0,0,46.26,11,8.48,8.48,0,0,1,54,20.17Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriseReseau);
export default __webpack_public_path__ + "static/media/prise-reseau.4a2e91e355d708f6d691e6f1252c77d0.svg";
export { ForwardRef as ReactComponent };